// @ts-strict-ignore
import React from 'react'

export const Logo = ({ brand }) => {
  return brand === 'uswitch' ? (
    <svg viewBox='0 0 880 260' xmlns='http://www.w3.org/2000/svg' className='PpcNav__Logo'>
      <g fill='#141423'>
        <path d='m275.92 167.49h24.23c1.38 12.8 7.88 17.33 22.66 17.33 14.38 0 20.09-4.53 20.09-12.21 0-7.29-4.53-10.84-19.89-13.4l-11.63-2c-21.86-3.74-33.29-13.39-33.29-30.73 0-19.11 15-30.73 42.16-30.73 31.32 0 44.13 13.59 44.92 34.47h-23.45c-.59-13-8.67-16.74-21.47-16.74-12 0-17.73 4.53-17.73 11.82 0 7.48 5.91 10.44 16.94 12.41l12.81 2c24.42 4.33 35.26 13.4 35.26 30.93 0 20.49-16.75 31.92-45.11 31.92-28.96 0-44.92-10.45-46.5-35.07z'></path>
        <path d='m531.83 98.14-33.49 101.66h-26l-12.81-41.8c-3-10.05-5.91-20.29-8.67-30.34-2.76 10.05-5.52 20.29-8.47 30.34l-12.61 41.8h-26l-33.49-101.66h26.59l11.43 38c3.54 11.63 6.89 23.64 10 35.27 3-11.82 6.11-23.64 9.66-35.46l11.23-37.83h23.64l11.27 37.88c3.54 11.82 6.7 23.64 9.65 35.46 3.15-11.63 6.5-23.64 10.05-35.27l11.42-38z'></path>
        <path d='m541.48 98.14h24.82v101.66h-24.82zm.2-36.44h24.42v23.24h-24.42z'></path>
        <path d='m619.29 117.05v55c0 6.7 3.35 8.86 11.63 8.86h8.47v18.89c-4.53.39-9.06.78-13 .78-21.48 0-31.72-7.28-31.72-26v-57.53h-15.76v-18.91h15.76v-29.55h24.62v29.55h20.1v18.91z'></path>
        <path d='m647.46 149c0-32.51 19.9-53.19 50.24-53.19 26.59 0 44.32 15.17 47.28 39h-24.82c-2.37-12.6-11.43-18.32-22.46-18.32-14.78 0-24.82 10.25-24.82 32.51s10.44 32.51 24.82 32.51c11.23 0 20.88-6.11 22.85-19.51h24.82c-2.75 24.82-21.67 40.19-47.67 40.19-30.14-.03-50.24-20.71-50.24-53.19z'></path>
        <path d='m850.37 132.42v67.38h-24.82v-63.24c0-13-6.5-19.31-19.11-19.31-10.83 0-22.65 7.49-22.65 25.61v56.94h-24.79v-140.27h24.83v52.2a37.27 37.27 0 0 1 30.93-16c21.24.05 35.61 12.46 35.61 36.69z'></path>
        <path d='m29.64 26.24v207h207v-207zm162.21 120.76c0 36.45-22.66 55.76-58.71 55.76-35.26 0-58.71-19.31-58.71-55.76v-87.48h26.57v87.67c0 22.06 12 32.51 32.11 32.51s32.11-10.45 32.11-32.51v-87.67h26.6z'></path>
      </g>
    </svg>
  ) : (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 293.99 61.6' className='PpcNav__Logo'>
      <g id='Money_logo'>
        <path
          style={{ fill: '#fec340' }}
          d='M34.6,19.33l-.05-.09.05-.06L14.34,1a4,4,0,0,0-.75-.56h0A3.27,3.27,0,0,0,12,0h-.25A4.28,4.28,0,0,0,8.16,3.6h0v0c0,.08,0,.17,0,.26v0l0,.22L8,4.39l0,1L8.1,6.51l.06.22,13.47,27,.1-.11.14.28Z'
        />
        <path
          style={{ fill: '#f4793b' }}
          d='M34.87,54.9,34.77,19l-.17.15h0l-.21.24L21.73,33.63l9.48,18.91a4,4,0,0,0,3,2.35h0l.38,0h.27Z'
        />
        <path
          style={{ fill: '#a64470' }}
          d='M61.56,6.59l-.47-2.71h0A4.32,4.32,0,0,0,57.47,0h-.26a3.26,3.26,0,0,0-1.57.43h0a4.36,4.36,0,0,0-.75.55L34.6,19.19h0v.69l12.72,14,.15-.29.13.14Z'
        />
        <path
          style={{ fill: '#faa73f' }}
          d='M8.1,3.88h0l-8,48a3,3,0,0,0-.06.58,2.25,2.25,0,0,0,2,2.45,1.8,1.8,0,0,0,1.38-.69L21.73,33.63l-13-26A5.65,5.65,0,0,1,8,4.9a6.64,6.64,0,0,1,.08-1'
        />
        <path
          style={{ fill: '#924a8b' }}
          d='M61.1,3.88a5.81,5.81,0,0,1,.08,1,5.66,5.66,0,0,1-.67,2.73l-13,26,18.36,20.6h0a1.8,1.8,0,0,0,1.38.69,2.25,2.25,0,0,0,2-2.45,2.81,2.81,0,0,0-.06-.58l-8-48h0'
        />
        <path
          style={{ fill: '#db4d75' }}
          d='M34.6,19.19h0V54.91A3.89,3.89,0,0,0,38,52.53h0l9.48-18.91L34.6,19.19'
        />
        <path
          style={{ fill: '#35454e' }}
          d='M135.41,23.52V43a3.08,3.08,0,0,1-3.11,3,3,3,0,0,1-3-3V24.74c0-5.68-1.76-8.53-6.89-8.53s-7.92,3.45-9.75,6.49V43a3.08,3.08,0,0,1-3.11,3,3,3,0,0,1-3-3V24.74c0-5.68-1.76-8.53-6.9-8.53s-7.91,3.45-9.74,6.49V43a3.08,3.08,0,0,1-3.11,3,3,3,0,0,1-3-3V14a3.09,3.09,0,0,1,3-3.12A3.15,3.15,0,0,1,89.83,14v2.77c1.89-2.63,5.07-6.22,11.49-6.22a11,11,0,0,1,10.35,7,13.73,13.73,0,0,1,12.45-7C132.09,10.53,135.41,17.5,135.41,23.52Z'
        />
        <path
          style={{ fill: '#35454e' }}
          d='M177.07,28.46c0,10.69-6.9,17.93-17.32,17.93s-17.32-7.24-17.32-17.93,6.83-17.93,17.32-17.93S177.07,17.78,177.07,28.46Zm-6.16-.07c0-8.93-6-12.24-11.16-12.24s-11.16,3.32-11.16,12.24,6,12.37,11.16,12.37S170.91,37.39,170.91,28.39Z'
        />
        <path
          style={{ fill: '#35454e' }}
          d='M215.68,23.79V43a3.08,3.08,0,0,1-3.11,3,3,3,0,0,1-3-3V24.47c0-5.14-2.16-8.25-7.43-8.25-4.87,0-8.39,3.11-11.1,6.49V43a3.08,3.08,0,0,1-3.11,3,3,3,0,0,1-3-3V14a3,3,0,0,1,3-3.12A3.1,3.1,0,0,1,191,14v2.77c2.84-3.11,6.56-6.22,12.59-6.22C211.28,10.53,215.68,16.56,215.68,23.79Z'
        />
        <path
          style={{ fill: '#35454e' }}
          d='M254.62,40.9a3.08,3.08,0,0,1-1.75,2.51c-3,1.69-6,3-11.85,3-11,0-17.51-6.56-17.51-17.93,0-9.13,4.94-17.93,16.16-17.93,10.42,0,16.1,8.05,16.1,17a3,3,0,0,1-3.12,3.05H229.73c.68,6.08,4.53,10,11.84,10a18.47,18.47,0,0,0,9.13-2.09,2.45,2.45,0,0,1,1.21-.27A2.65,2.65,0,0,1,254.62,40.9ZM229.73,25.62h20c-.4-7-5.68-9.88-10-9.88S230.14,18.59,229.73,25.62Z'
        />
        <path
          style={{ fill: '#35454e' }}
          d='M293.78,15.13,275.32,59.51a3,3,0,0,1-2.84,2.09,2.94,2.94,0,0,1-2.91-3,3.05,3.05,0,0,1,.21-1.08l4.4-11.29-12.72-31a3.55,3.55,0,0,1-.28-1.28,3.09,3.09,0,0,1,3-3.12,3.14,3.14,0,0,1,2.84,1.89l10.41,25.84,10.62-25.7A3,3,0,0,1,294,14,3,3,0,0,1,293.78,15.13Z'
        />
      </g>
    </svg>
  )
}
